import cloneDeep from 'lodash/cloneDeep';
import { useCallback } from 'react';
import { IEquipmentInspectionsReportSettings } from 'types/EquipmentInspectionsReportSettings';
import useMemberFeatureSettingsUpdate from '../member/useMemberFeatureSettingsUpdate';
import useMemberSettings from '../member/useMemberSettings';

export default function useEquipmentInspectionsReportSettingsUpdate() {
  const memberSettings = useMemberSettings();
  const updateFeatureSettings = useMemberFeatureSettingsUpdate();

  return useCallback(
    <K extends keyof IEquipmentInspectionsReportSettings>(
      keysAndPayloads: { key: K; payload: IEquipmentInspectionsReportSettings[K] }[]
    ) => {
      const cloned = cloneDeep(memberSettings?.web?.features?.equipmentInspectionsReport);

      const mapped = keysAndPayloads.reduce(
        (acc, cur) => ({
          ...acc,
          [cur.key]: cur.payload,
        }),
        cloned
      );

      return updateFeatureSettings('equipmentInspectionsReport', mapped);
    },
    [memberSettings, updateFeatureSettings]
  );
}
